import BaseButton from '@portalterreno/react-ui-core/Button';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import { closeModalForm } from '../../../redux/slices/showPhoneForm';
import { RootState } from '../../../redux/store';
import StyledDesktop from '../../ReportForm/StyledDesktop';
import { FooterProps } from '.';

const DesktopFooter: React.FC<FooterProps> = (props) => {
  const dispatch = useDispatch();

  const state = useSelector(
    (state: RootState) => ({
      isShowPhoneButtonLoading: state.contactForm.isShowPhoneButtonLoading,
      isShowPhoneFormSent: state.contactForm.isShowPhoneFormSent
    }),
    shallowEqual
  );

  const { t } = useTranslation('common');

  const submitText = t('send');
  const cancel = t('cancel');

  const handleOnClose = React.useCallback(() => {
    dispatch(closeModalForm());
  }, [dispatch]);

  return (
    <StyledDesktop {...props}>
      <BaseButton
        fullWidth
        variant='contained'
        type='submit'
        color='midnight'
        disabled={state.isShowPhoneFormSent || state.isShowPhoneButtonLoading}
        loading={state.isShowPhoneButtonLoading}
      >
        {submitText}
      </BaseButton>
      <BaseButton
        fullWidth
        onClick={handleOnClose}
        loading={state.isShowPhoneButtonLoading}
        variant='outlined'
        color='secondary'
        type='button'
      >
        {cancel}
      </BaseButton>
    </StyledDesktop>
  );
};

export default DesktopFooter;
